<div class="resetPassword">
  <div class="logo">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-sm-6">
          <div class="logo-main">
            <div class="ourlogo">
              <img src="/assets/images/Piqet_NewLogo.png" alt="Logo" />
            </div>
            <div class="rightside-text">
              <div class="logo1">
                Powering your <br />
                sustainability journey
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngrxLet="authFacade.isPasswordUpdated$ as isPasswordUpdated">
    <div *ngIf="!isPasswordUpdated; else SubmitSuccessContainer">
      <form [formGroup]="changePasswordForm" (ngSubmit)="submit()" class="contactus-forms">
        <div class="content">
          <p class="password-heading">Take a moment to secure your password</p>
          <p class="password-text">
            Before moving ahead, we recommend changing your default password to protect your
            personal information.
          </p>
          <!-- <label>Current password</label> -->
          <div
            *ngIf="isErrorpwd && changePasswordForm.controls['oldPassword']?.value"
            class="input-error pb-3"
          >
            Current password and new password is same, please enter different password
          </div>
          <div class="form-group required">
            <div class="services-form">
              <input
                [type]="fieldTextType ? 'text' : 'password'"
                formControlName="oldPassword"
                maxlength="50"
                placeholder="Enter current password"
                (keyup)="comparePasswords()"
              />
              <label>Current password</label>
              <div class="input-group-append">
                <span class="input-group-text">
                  <img
                    [src]="fieldTextType ? 'assets/images/Eye.png' : 'assets/images/EyeCross.png'"
                    (click)="toggleFieldOldPwd()"
                  />
                </span>
              </div>

              <div
                *ngIf="
                  (changePasswordForm.controls['oldPassword']?.touched &&
                    changePasswordForm.controls['oldPassword']?.invalid) ||
                  changePasswordForm.controls['oldPassword'].hasError('whitespace')
                "
                class="input-error"
              >
                The current password field is required.
              </div>
            </div>
          </div>
          <div class="form-group required">
            <div class="services-form">
              <input
                [type]="fieldTextTypeNewPwd ? 'text' : 'password'"
                formControlName="Password"
                maxlength="50"
                placeholder="Enter New password"
                (keyup)="validationsPassword()"
              />
              <label>New password</label>
              <div class="input-group-append">
                <span class="input-group-text">
                  <img
                    [src]="
                      fieldTextTypeNewPwd ? 'assets/images/Eye.png' : 'assets/images/EyeCross.png'
                    "
                    (click)="toggleFieldNewPwd()"
                  />
                </span>
              </div>

              <div class="security-tabs">
                <p [ngClass]="upperCaseCharactersflag ? 'hightlightText' : 'NonhightlightText'">
                  One uppercase character
                </p>
                <p [ngClass]="lowerCaseCharactersflag ? 'hightlightText' : 'NonhightlightText'">
                  One lowercase character
                </p>
                <p [ngClass]="numberCharactersflag ? 'hightlightText' : 'NonhightlightText'">
                  One number
                </p>
                <p
                  class="pe-2"
                  [ngClass]="specialCharactersflag ? 'hightlightText' : 'NonhightlightText'"
                >
                  One special character
                </p>
                <p class="pe-2" [ngClass]="minLengthsflag ? 'hightlightText' : 'NonhightlightText'">
                  8 characters minimum
                </p>
              </div>
            </div>
          </div>
          <div class="form-group required">
            <div class="services-form">
              <input
                [type]="fieldTextTypeConfirmPwd ? 'text' : 'password'"
                formControlName="ConfirmPassword"
                maxlength="50 "
                placeholder="Enter Confirm password"
              />
              <label>Confirm password</label>
              <div class="input-group-append">
                <span class="input-group-text">
                  <img
                    [src]="
                      fieldTextTypeConfirmPwd
                        ? 'assets/images/Eye.png'
                        : 'assets/images/EyeCross.png'
                    "
                    (click)="toggleFieldConfirmPwd()"
                  />
                </span>
              </div>
              <div
                *ngIf="
                  changePasswordForm.get('ConfirmPassword')?.touched &&
                  changePasswordForm.get('ConfirmPassword')?.invalid
                "
                class="input-error"
              >
                {{
                  !changePasswordForm.get('ConfirmPassword')?.value
                    ? 'The confirm password field is required.'
                    : 'The password and confirm password fields do not match'
                }}
              </div>
            </div>
          </div>
          <div class="form-actions">
            <div>
              <button
                style="width: 100%"
                (click)="submit()"
                class="modelBtn"
                [disabled]="!changePasswordForm.valid || !submitted"
              >
                Secure my account
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <ng-template #SubmitSuccessContainer>
      <div class="text-black text-center">
        <p class="successPwd">Your password updated successfully</p>
        <p class="redirectDashboard">You will be redirected to your dashboard in a moment...</p>
      </div>
    </ng-template>
  </ng-container>
</div>
